module.exports = __webpack_public_path__ + "img/Nidersan_Selvanathan_Chan_Logistik_ 14.803bc882.jpg";